<template>
  <component-wrapper class="cookie-declaration-fi">
    <grid-container-fi v-if="isMounted">
      <div class="fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12">
        <div
          ref="cookieDeclaration"
          class="cookie-declaration-fi__content richtext-fi"
        />
      </div>
    </grid-container-fi>

    <loading-indicator
      v-else
      variant="spinnerLocal"
    />
  </component-wrapper>
</template>

<script>
import { LoadingIndicator } from 'atoms';
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import GridContainerFi from 'components/grid-fi/GridContainerFi';

export default {
  name: 'CookieDeclaration',
  components: {
    ComponentWrapper,
    GridContainerFi,
    LoadingIndicator,
  },
  data() {
    return {
      isMounted: false,
    };
  },
  async mounted() {
    this.isMounted = true;
    await this.$nextTick();

    if (this.$fischer.cookieBotId() && this.$refs.cookieDeclaration) {
      const cookiebotScript = document.createElement('script');
      cookiebotScript.type = 'text/javascript';
      cookiebotScript.setAttribute(
        'src',
        `https://consent.cookiebot.com/${this.$fischer.cookieBotId()}/cd.js`,
      );
      cookiebotScript.async = true;
      this.$refs.cookieDeclaration.appendChild(cookiebotScript);
    } else {
      if (!this.$refs.cookieDeclaration) {
        console.error('Missing cookiebot ref');
      } else {
        console.info('No CookieBot ID defined for this site');
      }
    }
  },
};
</script>

<style lang="scss">
@import './cookie-declaration-fi-unscoped';
</style>
